import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { productsRouteApi } from '../route/productsRouteApi';

export const useCurrentService = () => {
    const enterpriseId = useCurrentEnterpriseId();
    const { serviceId } = productsRouteApi.useParams();

    const query = useRepositorySuspenseQuery(
        'services',
        'getAll',
        {
            enterpriseIds: [enterpriseId],
            serviceIds: [serviceId],
        },
        {
            select: (response) => response.services[0],
        }
    );

    return query.data;
};
